var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	44914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e(521).then(() => (() => (__webpack_require__(96540))))))),
	86672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (Promise.all([__webpack_require__.e(5090), __webpack_require__.e(7979)]).then(() => (() => (__webpack_require__(40961))))))),
	8673: () => (loadStrictVersion("default", "chart.js", false, [1,4,4,3], () => (Promise.all([__webpack_require__.e(9095), __webpack_require__.e(8836)]).then(() => (() => (__webpack_require__(66118))))))),
	93466: () => (loadStrictVersion("default", "react-redux", false, [1,7,2,3], () => (Promise.all([__webpack_require__.e(7834), __webpack_require__.e(7251), __webpack_require__.e(5052), __webpack_require__.e(1910)]).then(() => (() => (__webpack_require__(61225))))))),
	32882: () => (loadStrictVersion("default", "draft-js", false, [2,0,10,5], () => (Promise.all([__webpack_require__.e(5745), __webpack_require__.e(3298), __webpack_require__.e(6479), __webpack_require__.e(2769), __webpack_require__.e(83), __webpack_require__.e(4914), __webpack_require__.e(1910)]).then(() => (() => (__webpack_require__(35143))))))),
	26522: () => (loadSingletonVersion("default", "react-router-dom", false, [1,18,2,0], () => (Promise.all([__webpack_require__.e(3976), __webpack_require__.e(7834), __webpack_require__.e(7251), __webpack_require__.e(3825), __webpack_require__.e(9409), __webpack_require__.e(6730)]).then(() => (() => (__webpack_require__(54625))))))),
	12571: () => (loadStrictVersion("default", "react-device-detect", false, [1,1,17,0], () => (Promise.all([__webpack_require__.e(3298), __webpack_require__.e(3132)]).then(() => (() => (__webpack_require__(15042))))))),
	16493: () => (loadStrictVersion("default", "@techsoftware/happay-widgets", false, [4,2,7,2], () => (Promise.all([__webpack_require__.e(3579), __webpack_require__.e(3976), __webpack_require__.e(7834), __webpack_require__.e(7251), __webpack_require__.e(8023), __webpack_require__.e(156), __webpack_require__.e(9461), __webpack_require__.e(597), __webpack_require__.e(9653), __webpack_require__.e(8329), __webpack_require__.e(2735), __webpack_require__.e(633), __webpack_require__.e(8370), __webpack_require__.e(6886), __webpack_require__.e(3408), __webpack_require__.e(299), __webpack_require__.e(290), __webpack_require__.e(4261), __webpack_require__.e(2624), __webpack_require__.e(471), __webpack_require__.e(8312), __webpack_require__.e(3449), __webpack_require__.e(6203), __webpack_require__.e(908), __webpack_require__.e(979), __webpack_require__.e(7527), __webpack_require__.e(9151), __webpack_require__.e(7618), __webpack_require__.e(6434), __webpack_require__.e(1616), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(64658))))))),
	31207: () => (loadStrictVersion("default", "axios", false, [2,0,20,0], () => (__webpack_require__.e(5386).then(() => (() => (__webpack_require__(72505))))))),
	37971: () => (loadStrictVersion("default", "redux", false, [1,4,0,5], () => (Promise.all([__webpack_require__.e(3976), __webpack_require__.e(578)]).then(() => (() => (__webpack_require__(82960))))))),
	41155: () => (loadStrictVersion("default", "redux-thunk", false, [1,2,3,0], () => (__webpack_require__.e(9593).then(() => (() => (__webpack_require__(1265))))))),
	68050: () => (loadStrictVersion("default", "redux-saga", false, [1,1,1,3], () => (__webpack_require__.e(7919).then(() => (() => (__webpack_require__(27701))))))),
	96994: () => (loadStrictVersion("default", "node-forge", false, [2,0,10,0], () => (Promise.all([__webpack_require__.e(9842), __webpack_require__.e(310)]).then(() => (() => (__webpack_require__(39547))))))),
	98337: () => (loadStrictVersion("default", "connected-react-router", false, [1,6,9,1], () => (Promise.all([__webpack_require__.e(3976), __webpack_require__.e(7834), __webpack_require__.e(7251), __webpack_require__.e(3825), __webpack_require__.e(9409), __webpack_require__.e(4561), __webpack_require__.e(7775)]).then(() => (() => (__webpack_require__(19315))))))),
	80305: () => (loadStrictVersion("default", "flux", false, [1,2,1,1], () => (__webpack_require__.e(1593).then(() => (() => (__webpack_require__(33198))))))),
	54527: () => (loadStrictVersion("default", "html2canvas", false, [1,1,4,1], () => (__webpack_require__.e(7383).then(() => (() => (__webpack_require__(20354))))))),
	49332: () => (loadStrictVersion("default", "react-lottie", false, [1,1,2,3], () => (Promise.all([__webpack_require__.e(1603), __webpack_require__.e(9255), __webpack_require__.e(1555)]).then(() => (() => (__webpack_require__(73049))))))),
	22291: () => (loadStrictVersion("default", "draftjs-to-html", false, [2,0,9,1], () => (__webpack_require__.e(8620).then(() => (() => (__webpack_require__(29987))))))),
	47496: () => (loadStrictVersion("default", "react-draft-wysiwyg", false, [1,1,14,7], () => (Promise.all([__webpack_require__.e(8112), __webpack_require__.e(1123)]).then(() => (() => (__webpack_require__(43754))))))),
	66472: () => (loadStrictVersion("default", "html-to-draftjs", false, [1,1,5,0], () => (Promise.all([__webpack_require__.e(8112), __webpack_require__.e(5248)]).then(() => (() => (__webpack_require__(47340))))))),
	76468: () => (loadStrictVersion("default", "react-quill", false, [1,1,3,5], () => (Promise.all([__webpack_require__.e(5090), __webpack_require__.e(8023), __webpack_require__.e(7037), __webpack_require__.e(1847), __webpack_require__.e(9317), __webpack_require__.e(3151)]).then(() => (() => (__webpack_require__(45708))))))),
	15216: () => (loadStrictVersion("default", "chartjs-plugin-datalabels", false, [1,2,2,0], () => (Promise.all([__webpack_require__.e(9095), __webpack_require__.e(8836), __webpack_require__.e(9885)]).then(() => (() => (__webpack_require__(19203))))))),
	37581: () => (loadStrictVersion("default", "chart.js-plugin-labels-dv", false, [1,5,0,1,,"beta"], () => (Promise.all([__webpack_require__.e(9095), __webpack_require__.e(8836), __webpack_require__.e(2126)]).then(() => (() => (__webpack_require__(59782))))))),
	54511: () => (loadStrictVersion("default", "react-chartjs-2", false, [1,5,2,0], () => (__webpack_require__.e(5042).then(() => (() => (__webpack_require__(44731))))))),
	81343: () => (loadStrictVersion("default", "jspdf", false, [1,2,5,1], () => (Promise.all([__webpack_require__.e(8185), __webpack_require__.e(524)]).then(() => (() => (__webpack_require__(13596)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1910": [
		86672
	],
	"2464": [
		12571,
		16493,
		31207,
		37971,
		41155,
		68050,
		96994,
		98337
	],
	"2882": [
		32882
	],
	"3466": [
		93466
	],
	"3664": [
		80305
	],
	"4527": [
		54527
	],
	"4914": [
		44914
	],
	"5838": [
		49332
	],
	"6672": [
		86672
	],
	"7583": [
		15216,
		37581,
		54511,
		81343
	],
	"8673": [
		8673
	],
	"9023": [
		26522
	],
	"9716": [
		22291,
		47496,
		66472,
		76468
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}